import * as yup from "yup";

export const signUpValidation = yup.object().shape({
  email: yup
    .string()
    .required("Please enter you email address")
    .matches(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      "Please enter valid email"
    )
});
export const loginValidation = yup.object().shape({
  email: yup
    .string()
    .required("Please enter you email address")
    .matches(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      "Please enter valid email"
    ),
  password: yup.string().required("Please enter password.")
  // .matches(
  //   /^(?=.*[A-Z])(?=.*[~!@#$%^&*()/_=+[\]{}|;:,.<>?-])(?=.*[0-9])(?=.*[a-z]).{8,14}$/,
  //   "Only accept One Uppercase and atleast one special characters and numbers."
  // )
  // .min(8, "Minimum 8 characters is required.")
  // verificationCode: yup.string().required('Please enter OTP'),
});
export const subAdminValidation = yup.object().shape({
  fullname: yup.string().required("Please enter you full name"),
  email: yup
    .string()
    .required("Please enter you email address")
    .matches(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      "Please enter valid email"
    ),
  password: yup
    .string()
    .required("Please enter password.")
    .matches(
      /^(?=.*[A-Z])(?=.*[~!@#$%^&*()/_=+[\]{}|;:,.<>?-])(?=.*[0-9])(?=.*[a-z]).{8,14}$/,
      "Only accept One Uppercase and atleast one special characters and numbers."
    )
    .min(8, "Minimum 8 characters is required.")
});
export const addBuyersValidation = yup.object().shape({
  walletAddress: yup.string().required("Please enter your wallet address"),
  fractionToBuy: yup
    .string()
    .required("Please enter Fractions")
    .test("is-positive", "Fraction must be a positive number", (value) => {
      return value && Number(value) >= 0;
    }),
  totalPrice: yup.string().required("Please enter total price of fraction")
});

export const userValidation = yup.object({
  fullname: yup.string().required("Full name is required"),
  email: yup
    .string()
    .required("Email is required")
    .matches(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      "Please enter valid email"
    ),
  mobile: yup
    .string()
    .required("Mobile number is required")
    .matches(
      /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
      "Please enter only 10 digit number."
    ),
  city: yup.string().nullable(),
  country: yup.string().nullable(),
  whatsapp: yup
    .string()
    .matches(
      /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
      "Please enter only 10 digit number."
    )
    .nullable(),
  telegram: yup.string().nullable()
});
export const QrCodeValidation = yup.object().shape({
  upi: yup.string().required("Required"),
  image: yup.string().required("Required")
});

export const AccountValidation = yup.object().shape({
  accountHolderName: yup.string().required("Required"),
  accountNumber: yup
    .string()
    .matches(/^[0-9]{9,18}$/, "Invalid account number")
    .required("Required"),
  bankName: yup.string().required("Required"),
  ifscCode: yup
    .string()
    .matches(/^[A-Za-z]{4}[0-9]{7}$/, "Invalid IFSC code")
    .required("Required")
});

export const merchantValidationSchema = yup.object().shape({
  fullname: yup.string().required("Full name is required"),
  email: yup
    .string()
    .required("Email is required")
    .matches(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      "Please enter valid email"
    ),
  websiteDomain: yup.string().required("Website Domain is required"),
  platformName: yup.string().required("Platform Name is required"),
  callbackUrl: yup.string().required("Call Back Url is required"),
  uin: yup.string().required("uin is required"),
  walletAddress: yup.string().required("Wallet Address is required"),
  howToFind: yup.string().required("How to find is required")
});

export const addSubAdminValidation = yup.object().shape({
  firstname: yup.string().required("Please enter your first name"),
  lastname: yup.string().required("Please enter your last name"),
  email: yup
    .string()
    .required("Please enter email address")
    .matches(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      "Please enter valid email"
    ),
  password: yup
    .string()
    .required("Please enter password")
    .matches(
      /^(?=.*[A-Z])(?=.*[~!@#$%^&*()/_=+[\]{}|;:,.<>?-])(?=.*[0-9])(?=.*[a-z]).{8,14}$/,
      "Only accept One Uppercase and atleast one special characters and numbers."
    )
    .min(8, "Minimum 8 characters is required")
});

export const updateUserPasswordValidation = yup.object().shape({
  newPassword: yup
    .string()
    .required("Please enter new password")
    .matches(
      /^(?=.*[A-Z])(?=.*[~!@#$%^&*()/_=+[\]{}|;:,.<>?-])(?=.*[0-9])(?=.*[a-z]).{8,14}$/,
      "Only accept One Uppercase and at least one special character and number."
    )
    .min(8, "Minimum 8 characters is required"),

  newConfirmPassword: yup
    .string()
    .required("Please enter confirm new password")
    .oneOf([yup.ref("newPassword"), null], "Passwords must match")
    .matches(
      /^(?=.*[A-Z])(?=.*[~!@#$%^&*()/_=+[\]{}|;:,.<>?-])(?=.*[0-9])(?=.*[a-z]).{8,14}$/,
      "Only accept One Uppercase and at least one special character and number."
    )
    .min(8, "Minimum 8 characters is required")
});
export const AddUserValidation = yup.object().shape({
  referralCode: yup.string().required("Please enter yout referral code"),
  commissionPercentage: yup
    .string()
    .required("Please enter your commission percentage")
});

export const addUserValidation = yup.object().shape({
  firstname: yup
    .string()
    .required("Please enter your first name")
    .max(50, "First name is too long")
    .matches(/^[a-zA-Z\s]+$/, "Only letters and spaces are allowed"),

  lastname: yup
    .string()
    .required("Please enter your last name")
    .max(50, "Last name is too long")
    .matches(/^[a-zA-Z\s]+$/, "Only letters and spaces are allowed"),

  userName: yup
    .string()
    .required("Please enter your username")
    .max(30, "Username is too long"),

  email: yup
    .string()
    .required("Please enter your email address")
    .email("Please enter a valid email") // simpler & built-in
    .max(100, "Email exceeds limit"),

  password: yup
    .string()
    .required("Please enter a password")
    .min(8, "Minimum 8 characters is required")
    .max(20, "Maximum 20 characters is allowed")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).+$/,
      "Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character"
    ),

  country: yup.string().required("Please select a country"),
  organizationType: yup.string().required("Please select entity type"),

  organizationId: yup.string().required("Please select an organization")
});

export const updateUserValidation = yup.object().shape({
  firstname: yup
    .string()
    .required("Please enter your first name")
    .max(50, "First Name length invalid"),
  lastname: yup
    .string()
    .required("Please enter your last name")
    .max(50, "Last Name length invalid"),
  // address_line_1: yup.string().required("Please enter your address"),
  // address_line_2: yup.string().required("Please enter your second address"),
  email: yup
    .string()
    .required("Please enter you email address")
    .matches(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      "Please enter valid email"
    )
    .max(100, "Email exceeds limit")

  // mobile: yup.string().required("Mobile number is required")
});
export const updateAdminPasswordValidation = yup.object().shape({
  oldPassword: yup
    .string()
    .required("Please enter old password")
    .matches(
      /^(?=.*[A-Z])(?=.*[~!@#$%^&*()/_=+[\]{}|;:,.<>?-])(?=.*[0-9])(?=.*[a-z]).{8,14}$/,
      "Only accept One Uppercase and at least one special character and number."
    )
    .min(8, "Minimum 8 characters is required"),

  newPassword: yup
    .string()
    .required("Please enter new password")
    .matches(
      /^(?=.*[A-Z])(?=.*[~!@#$%^&*()/_=+[\]{}|;:,.<>?-])(?=.*[0-9])(?=.*[a-z]).{8,14}$/,
      "Only accept One Uppercase and at least one special character and number."
    )
    .min(8, "Minimum 8 characters is required")
});
